// extracted by mini-css-extract-plugin
export default {"pie":"NetAPY_pie__H7c7M","tooltip":"NetAPY_tooltip__WXNqd","label":"NetAPY_label__zRmkj"};